"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _loadScript = _interopRequireDefault(require("load-script"));
var _Success = require("../common/Success");
var _Extension = require("../common/Extension");
var _constants = require("../constants");
var DROPBOX_SDK_URL = "https://www.dropbox.com/static/api/2/dropins.js";
var SCRIPT_ID = "dropboxjs";
var scriptLoadingStarted = false; // read more
// https://www.dropbox.com/developers/chooser

var DropboxChooser = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DropboxChooser, _Component);
  function DropboxChooser(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DropboxChooser);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DropboxChooser).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChoose", function () {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        extensions = _this$props.extensions;
      if (!_this.isDropboxReady() || disabled) {
        return null;
      }
      var _this$props2 = _this.props,
        cancel = _this$props2.cancel,
        linkType = _this$props2.linkType,
        multiselect = _this$props2.multiselect;
      window.Dropbox.choose({
        success: _this.onSuccess,
        cancel: cancel,
        linkType: linkType,
        multiselect: multiselect,
        extensions: (0, _Extension.getExtensions)(_constants.PROVIDERS.DROPBOX, extensions)
      });
      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isDropboxReady", function () {
      return !!window.Dropbox;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var children = _this.props.children;
      return _react.default.createElement("div", {
        onClick: _this.onChoose
      }, children || _react.default.createElement("button", {
        type: "button"
      }, " Open dropbox chooser "));
    });
    _this.onChoose = _this.onChoose.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSuccess = _this.onSuccess.bind((0, _assertThisInitialized2.default)(_this));
    _this.isDropboxReady = _this.isDropboxReady.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DropboxChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isDropboxReady() && !scriptLoadingStarted) {
        scriptLoadingStarted = true;
        var appKey = this.props.appKey;
        (0, _loadScript.default)(DROPBOX_SDK_URL, {
          attrs: {
            id: SCRIPT_ID,
            "data-app-key": appKey
          }
        });
      }
    }
  }, {
    key: "onSuccess",
    value: function () {
      var _onSuccess = (0, _asyncToGenerator2.default)( /*#__PURE__*/
      _regenerator.default.mark(function _callee(filesSelectedUser) {
        var success, resp, promises, proALL;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                success = this.props.success;
                resp = []; // THE MAPPING BETWEEN THE PROVIDER'S
                // RESPONSE AND THE OBJECT OF SUCCESS

                promises = [];
                filesSelectedUser.forEach(function (file) {
                  promises.push(fetch(file.link).then(function (res) {
                    return res.blob();
                  }) // Gets the response and returns it as a blob
                  .then(function (blob) {
                    return blob;
                  }));
                });
                _context.next = 6;
                return Promise.all(promises);
              case 6:
                proALL = _context.sent;
                proALL.forEach(function (file, index) {
                  resp.push(new _Success.Success(filesSelectedUser[index].id, filesSelectedUser[index].name, filesSelectedUser[index].bytes, null, _constants.PROVIDERS.DROPBOX, file));
                });
                if (success) {
                  success(resp);
                }
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  }]);
  return DropboxChooser;
}(_react.Component);
DropboxChooser.propTypes = {
  children: _propTypes.default.node,
  appKey: _propTypes.default.string.isRequired,
  success: _propTypes.default.func.isRequired,
  cancel: _propTypes.default.func,
  linkType: _propTypes.default.oneOf(["preview", "direct"]),
  multiselect: _propTypes.default.bool,
  extensions: _propTypes.default.arrayOf(_propTypes.default.string),
  disabled: _propTypes.default.bool
};
DropboxChooser.defaultProps = {
  children: null,
  cancel: function cancel() {},
  linkType: "direct",
  multiselect: false,
  disabled: false,
  extensions: []
};
var _default = DropboxChooser;
exports.default = _default;